import { Focus } from "lucide-react";
import { useRef } from "react";
import { useViewer } from "@/hooks/useViewer";
import { fr } from "@/i18n/fr";
import { useViewerStore } from "@/state/store";
import { StepCard } from "./StepCard";

export function Stage() {
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const viewRef = useRef<HTMLDivElement>(null);
	useViewer(canvasRef, viewRef);
	const status = useViewerStore((s) => s.status);
	const progress = useViewerStore((s) => s.progress);
	const error = useViewerStore((s) => s.error);
	const requestRecenter = useViewerStore((s) => s.requestRecenter);
	return (
		<section className="stage">
			<div className="view" ref={viewRef}>
				<canvas ref={canvasRef} aria-label="Vue 3D du montage" />
				{status !== "ready" && (
					<output className={`loading ${status === "error" ? "error" : ""}`}>
						<div className="box">
							<b>{status === "error" ? fr.loadError : fr.loading}</b>
							{status === "error" ? error : fr.loadingDetail}
							{status !== "error" && (
								<div className="bar">
									<i style={{ width: `${Math.round(progress * 100)}%` }} />
								</div>
							)}
						</div>
					</output>
				)}
				<div className="viewtools">
					<button
						className="pill"
						title={fr.recenterTitle}
						onClick={requestRecenter}
						type="button"
					>
						<Focus aria-hidden="true" />
						{fr.recenter}
					</button>
					<span className="pill touchhint">{fr.touchHint}</span>
				</div>
			</div>
			<StepCard />
		</section>
	);
}
